export const ASSIGNMENTS_PAGINATION_INITIAL_STATE = {
  currentPage: 1,
  total: 0,
  pageSize: 10000
}
